$(document).ready(function(){
    if (currentUrl.includes('report')) {
        let table;
         if ($.fn.DataTable) {
            if ($.fn.DataTable.isDataTable('#reportTable')) {
                $('#reportTable').DataTable().clear().destroy();
            }
            table = $('#reportTable').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            searching: false,
            order: [],
            pagingType: 'full_numbers',
            dom: '<"top d-flex justify-content-between align-items-center"<"left-section"l><"center-section"B><"right-section"f>>rt<"bottom"ip>',
            buttons: [
                { extend: 'copy', className: 'btn-sm' },
                { extend: 'csv', className: 'btn-sm' },
                { extend: 'excel', className: 'btn-sm' },
                { extend: 'pdf', className: 'btn-sm' },
                { extend: 'print', className: 'btn-sm' }
            ],
            columns: [
                { 
                    data: 'carrier_name',
                    name: 'carrier_name',
                    orderable: true,
                    searchable: true,
                    render: function(data, type, row) {
                        return row.carrier_name || '-';
                    }
                },
                { 
                    data: 'orderNumber', 
                    name: 'orders.orderNumber',
                    orderable: true,
                    searchable: true,
                    render: function(data, type, row) {
                        return row.orderNumber || '-';
                    }
                },
                { 
                    data: 'tracking_number', 
                    name: 'tracking_number',
                    orderable: true,
                    searchable: true
                },
                { 
                    data: 'shipped_date', 
                    name: 'shipped_date',
                    orderable: true,
                    searchable: true
                },
                { 
                    data: 'expected_delivery_date', 
                    name: 'expected_delivery_date',
                    orderable: true,
                    searchable: true
                },
                { 
                    data: 'delivered_date', 
                    name: 'delivered_date',
                    orderable: true,
                    searchable: true
                },
                { 
                    data: 'status', 
                    name: 'status',
                    orderable: true,
                    searchable: true,
                    render: function(data, type, row) {
                        let status = row.status ? String(row.status).charAt(0).toUpperCase() + String(row.status).slice(1) : '-';
                        return status.replace("_", " ");
                    }
                },
                { 
                    data: 'status_updated_at',
                    name: 'status_updated_at',
                    orderable: true,
                    searchable: true,
                    render: function(data, type, row) {
                        return row.status_updated_at || '-';
                    }
                },
                { 
                    data: 'last_update',
                    name: 'last_update',
                    orderable: true,
                    searchable: true
                }
            ],
            ajax: {
                url: "/report/tracker",
                data: function (d) {
                    d.isFilter = $('#isFilter').val();
                    d.order_number = $('#order').val() || '';
                    d.status = $('#status').val() || '';
                    d.carrier = $('#carrier').val() || '';
                    d.creator = $('#creator').val() || '';
                    d.date_type = $('#date_type').val() || '';
                    d.start_date = $('#start_date').val() || '';
                    d.end_date = $('#end_date').val() || '';
                    d.search = $('#search').val() || '';
                    d.report_type = $('#report_type').val() || '';
                }
            }
        }); 
        }
 
        $('#reportFilter').on('click', function() {
            const order = $('#order').val();
            const status = $('#status').val();
            const carrier = $('#carrier').val();
            const creator = $('#creator').val();
            const date_type = $('#date_type').val();
            const start_date = $('#start_date').val();
            const end_date = $('#end_date').val();
            const search = $('#search').val();
            const report_type =$('#report_type').val();
     
            if (!report_type && !search && !order && !status && !carrier && !creator && !date_type && !start_date && !end_date) {
                showNotification("Please apply at least one filter.", "Filter With empty data")
                return;
            }
    
            if (!date_type && start_date && end_date) {
                showNotification("Please select a date type to filter by date.", "Filter With empty data")
                return;
            }
    
            if (date_type && (!start_date || !end_date)) {
                showNotification("Please select a date range to filter by date.", "Filter With empty data")
                return;
            }
    
            $('#isFilter').val('1');
            table.draw(); 
        });
    
        $('#clearFilter').on('click', function() {
            $('#report_type, #reportType, #order, #status, #carrier, #creator, #date_type, #search').val('').trigger('change');
            
            const picker = $('#dateRangePicker').data('daterangepicker');
    
            picker.setStartDate(moment()); 
            picker.setEndDate(moment());
    
            $('#dateRangePickerInput').val('');
            $('#start_date').val('');
            $('#end_date').val('');
            $('#isFilter').val('0');
    
            table.draw();
        });
    }

});
